module.exports = __webpack_public_path__ + "assets/img/navBar.6a573f44.svg";